import { render, staticRenderFns } from "./FavoriteRibbon.vue?vue&type=template&id=71c6dab9&"
import script from "./FavoriteRibbon.vue?vue&type=script&lang=js&"
export * from "./FavoriteRibbon.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteRibbon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports